import { useEffect } from 'react';

import useUI from 'hooks/use-ui';

export default function useIframeHeightOverride(height) {
  const UI = useUI();

  useEffect(() => {
    if (!height) {
      return;
    }
    UI.iframeHeightOverride = height;

    // eslint-disable-next-line i18next/no-literal-string
    UI.embeddedEventDispatcher('iframe:resize:override', { height });

    return () => (UI.iframeHeightOverride = null);
  }, [UI, height]);
}
